module.exports = __webpack_public_path__ + "img/A高通锐化100.c5652805.png";